import React from "react";
import { Modal } from "antd";
import { Api } from "../services";

// Batches mirror their course's curriculum, so a change that drops chapters or a subject also drops
// them from the batches, along with the tests and library content on them. Asks first when it would;
// otherwise, or if the check itself fails, just carries on.
export const confirmCurriculumImpact = (params, proceed, cancel = null) => {
  Api.post("/subjects/curriculum-impact", {}, { silent: true })
    .params(params)
    .send((response) => {
      if (!response?.affected) {
        proceed();
        return;
      }
      const what = response.wholeSubject
        ? `the subject "${response.subjectName}"`
        : `${response.chapterNames?.length > 1 ? "chapters" : "chapter"} ${response.chapterNames
            ?.map((name) => `"${name}"`)
            .join(", ")} of "${response.subjectName}"`;
      Modal.confirm({
        title: "This change affects existing content",
        width: 520,
        content: (
          <div>
            <div>This removes {what} from the batches below. Their linked content will no longer be shown under it:</div>
            <ul style={{ marginTop: 10, paddingLeft: 18 }}>
              {response.batches.map((batch) => (
                <li key={batch.id}>
                  <b>{batch.name}</b>: {batch.tests} {batch.tests === 1 ? "test" : "tests"}, {batch.library}{" "}
                  {batch.library === 1 ? "library item" : "library items"}
                </li>
              ))}
            </ul>
          </div>
        ),
        okText: "Continue",
        cancelText: "Cancel",
        onOk: proceed,
        onCancel: () => cancel && cancel(),
      });
    });
};
